module.exports = __webpack_public_path__ + "asset/image-Charts-340df7b648e56827.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Charts.svg
// module id = zvwG
// module chunks = 0